export enum ReservationTypes {
    Cualquiera = 0,
    Reconocimiento = 1,
    PruebaCOVID = 2,
    Otro = 3
}